import { LocaleAction } from '../actions/locale';
import { SET_LOCALE } from '../constants/actionTypes';
import { Reducer } from "redux";

/**
 * Locale state
 */
interface LocaleState {
  locale: string
}

/**
 * Initial locale state
 */
const initialState: LocaleState = {
  locale: "fi"
}

/**
 * Redux reducer for locale
 *
 * @param state store state of locale
 * @param action action of locale
 */
export const localeReducer: Reducer<LocaleState, LocaleAction> = (state = initialState, action): LocaleState => {
  switch (action.type) {
    case SET_LOCALE:
      return {
        ...state,
        locale: action.locale
      };
    default:
      return state;
  }
}